import { carouselI18n, defaultCarouselSlideTypeName, SplideI18n } from '@/js/App/Carousel/i18n'
import Splide, { Options } from '@splidejs/splide'
import { deepMerge } from 'collapsable.js'

export interface HTMLCarouselElement extends HTMLElement {
	carousel: Splide
}

export default class Carousel {
	public static readonly selector = '.js-carousel'
	public readonly element: HTMLCarouselElement

	public static readonly defaultOptions: Options = {
		autoWidth: true,
		mediaQuery: 'min',
		gap: 'var(--column-gap)',
		rewind: true
	}

	public constructor(element: HTMLElement) {
		const options: Options = {}

		const instanceI18n = this.getI18N(element)
		if (instanceI18n) {
			options.i18n = instanceI18n
		}

		const instance: Splide = new Splide(element, deepMerge({}, Carousel.defaultOptions, options))
		instance.mount()

		const carouselWrapperCarousel = element as HTMLCarouselElement
		carouselWrapperCarousel.carousel = instance

		this.element = carouselWrapperCarousel
	}

	public destroy() {
		this.element.carousel.destroy(true)
	}

	private getI18N(element: HTMLElement): SplideI18n | null {
		const htmlLang = document.documentElement.lang.toLowerCase()

		if (!(htmlLang in carouselI18n)) {
			return null
		}

		const slideName: string = element.dataset.carouselSlideTypeName || defaultCarouselSlideTypeName
		const instanceI18n = Object.assign({}, carouselI18n[htmlLang])

		Object.keys(instanceI18n).forEach(function (key) {
			instanceI18n[key] = instanceI18n[key].replace('%name', slideName)
		})

		return instanceI18n
	}
}
